import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import PromoBanner from "@/components/site/PromoBanner";
import SEO from "@/components/seo/SEO";
import ContactSection from "@/components/site/Contact";
import { Link } from "react-router-dom";
import { Mail, Clock, Globe } from "lucide-react";

const META = [
  {
    icon: Mail,
    label: "Email",
    value: "hello@vaymilo.com",
    href: "mailto:hello@vaymilo.com",
  },
  {
    icon: Clock,
    label: "Reply time",
    value: "1–2 business days",
  },
  {
    icon: Globe,
    label: "Hours",
    value: "Mon — Fri",
  },
];

const ContactPage = () => {
  return (
    <main
      data-testid="contact-page"
      className="min-h-screen bg-[#F7F7F4] flex flex-col"
    >
      <SEO
        title="Contact"
        description="Questions, partnerships, or a custom kit? Email hello@vaymilo.com — we reply from a real inbox."
        path="/contact"
      />
      <PromoBanner />
      <Header />

      {/* Page hero */}
      <section className="bg-[#F7F7F4] border-b border-[#E7E7E2]">
        <div className="max-w-7xl mx-auto px-6 md:px-10 pt-16 md:pt-24 pb-12 md:pb-16">
          <div className="overline">— Contact</div>
          <h1 className="mt-5 font-sora text-[44px] sm:text-[60px] lg:text-[76px] font-extrabold tracking-tight leading-[1.02] text-[#111111]">
            Say hello.
          </h1>
          <p className="mt-6 max-w-2xl font-manrope text-[17px] md:text-[19px] leading-[1.65] text-[#111111]/70">
            Questions, partnerships, custom kits, or just a thought — drop us a
            line. Every message lands in a real inbox and gets a real reply.
          </p>

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-px bg-[#E7E7E2] border border-[#E7E7E2] rounded-xl overflow-hidden max-w-2xl">
            {META.map((m) => {
              const Icon = m.icon;
              const inner = (
                <div className="bg-white px-5 py-5 flex items-start gap-3">
                  <Icon
                    size={16}
                    className="text-[#2563EB] mt-0.5"
                    strokeWidth={2}
                  />
                  <div>
                    <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#111111]/45">
                      {m.label}
                    </div>
                    <div className="mt-1 font-manrope text-[14px] text-[#111111]">
                      {m.value}
                    </div>
                  </div>
                </div>
              );
              return m.href ? (
                <a
                  key={m.label}
                  href={m.href}
                  className="hover:bg-[#F7F7F4] transition-colors"
                >
                  {inner}
                </a>
              ) : (
                <div key={m.label}>{inner}</div>
              );
            })}
          </div>
        </div>
      </section>

      <ContactSection />

      {/* Quick links */}
      <section className="bg-white border-t border-[#E7E7E2]">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[#E7E7E2] border border-[#E7E7E2] rounded-2xl overflow-hidden">
            <Link
              to="/products"
              className="bg-white p-7 md:p-8 hover:bg-[#F7F7F4] transition-colors"
            >
              <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#111111]/45">
                Looking for products?
              </div>
              <div className="mt-3 font-sora text-[20px] font-semibold text-[#111111]">
                Browse the catalog →
              </div>
            </Link>
            <Link
              to="/about"
              className="bg-white p-7 md:p-8 hover:bg-[#F7F7F4] transition-colors"
            >
              <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#111111]/45">
                Want to know us?
              </div>
              <div className="mt-3 font-sora text-[20px] font-semibold text-[#111111]">
                About Vaymilo →
              </div>
            </Link>
            <Link
              to="/#free-tools"
              className="bg-white p-7 md:p-8 hover:bg-[#F7F7F4] transition-colors"
            >
              <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#111111]/45">
                Just exploring?
              </div>
              <div className="mt-3 font-sora text-[20px] font-semibold text-[#111111]">
                Join the free list →
              </div>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
};

export default ContactPage;
